export const safeObject = <T>(obj?: T): T => obj ?? ({} as T);
